<template>
    <section class="cnc-services-section">
        <div class="container">
            <h2 class="section-title">Our 3D Printing Processes</h2>
            <div class="services-grid">
                <div class="service-card" v-for="(item, index) in serviceList" :key="index">
                    <div class="card-image">
                        <img :src="item.image" :alt="item.title" />
                    </div>
                    <div class="card-content">
                        <h3 class="card-title">{{ item.title }}</h3>
                        <p class="card-desc">{{ item.desc }}</p>
                
                    </div>
                </div>
            </div>

            <div class="action-buttons">
                <button class="btn-primary" @click="$router.push('/quote')">Get Instant Quote</button>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'printing_Services',
    setup() {
        const serviceList = [
            {
                image: require('@/assets/process/1.png'),
                title: 'SLA',
                desc: 'High-resolution resin printing for visual and precision prototypes.',
            },
              {
                image: require('@/assets/process/2.png'),
                title: 'MJF',
                desc: 'HP MJF uses a fusing agent and heat to create strong, functional parts with fine details and excellent mechanical properties.',
            },
              {
             image: require('@/assets/process/3.png'),
                title: "SLS",
                desc: 'SLS fuses powdered material layer by layer using a laser, producing robust and durable parts. It’s excellent for complex geometries and end-use applications.',
            },
              {
             image: require('@/assets/process/4.png'),
                title: "Metal (SLM)",
                desc: 'SLM melts metal powders with a laser to create high-strength, intricate metal parts. This process is ideal for aerospace, medical, and industrial applications.',
            },
        ]

        return { serviceList }
    },
}
</script>

<style scoped>
.cnc-services-section {
    width: 100% !important;
    background-color: #f0f3f4 !important;
    padding: 76px 20px;
    position: relative !important;
    z-index: 1;
}
.container {
    max-width: 1200px;
    margin: 0 auto !important;
    width: 100%;
    display: block;
}

.section-title {
    font-size: 29px !important;
    font-weight: 600 !important;
    color: #444 !important;
    text-align: center;
    margin-bottom: 30px;
    position: relative;
}

.services-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-bottom: 40px;
    grid-auto-rows: 1fr;
    width: 100%;
    box-sizing: border-box;
}

.service-card {
    background: #fff;
    border-radius: 0;
    overflow: hidden;
    border: 1px solid #e8e8e8;
    transition: box-shadow 0.2s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
    cursor: pointer;
    box-sizing: border-box;
}

.service-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.card-image {
    width: 100%;
    height: 254px;
    overflow: hidden;
    flex-shrink: 0;
}

.card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.card-content {
    padding: 20px;
    display: flex;
    flex-direction: column;
    flex: 1;
}

/* 核心修复：固定标题两行等高，解决desc错位 */
.card-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
    line-height: 1.3;
    flex-shrink: 0;
    height: 42px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 0px;
}

.card-desc {
    font-size: 16px;
    color: #6b7280;
    font-weight: 600;
    line-height: 1.6;
    margin-bottom: 0px;
}



.action-buttons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
}

.btn-primary {
    padding: 12px 30px;
    border: none;
    background: #16bc9c !important;
    color: #fff !important;
    font-size: 16px;
    font-weight: 600;
    border-radius: 4px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.btn-primary:hover {
    background: #13a68a !important;
}

@media (max-width: 992px) {
    .services-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 640px) {
    .services-grid {
        grid-template-columns: 1fr;
    }
    .action-buttons {
        flex-direction: column;
        width: 100%;
    }
    .btn-primary {
        width: 100%;
        justify-content: center;
    }
}
</style>